<div class="spinner-border" style="color: rgb(0 207 200 / 1)" role="status">
  <span class="sr-only">Loading...</span>
</div>
